import { c as _c } from "react/compiler-runtime";
import { RadioGroup } from '@xefi/x-react/form';
import { Tooltip } from '@xefi/x-react/tooltip';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import { t } from 'i18next';
import type { ChangeEvent } from 'react';
import { useMemo } from 'react';
import { QuestionImage } from '@/components/QuestionImage';
import type { QuestionChoice } from '@/models/question';
type RadioButtonsFieldProps = {
  choices: QuestionChoice[];
  value?: string;
  onChange: (value?: string) => void;
  canSelectNoOption: boolean;
  readOnly?: boolean;
  checkOverflow?: boolean;
  hideTooltip?: boolean;
};
export const RadioButtonsField = t0 => {
  const $ = _c(23);
  const {
    choices,
    onChange,
    canSelectNoOption,
    value,
    readOnly,
    checkOverflow: t1,
    hideTooltip: t2
  } = t0;
  const checkOverflow = t1 === undefined ? true : t1;
  const hideTooltip = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== checkOverflow) {
    t3 = choice => !(checkOverflow && !choice.is_limit_overflowed || !checkOverflow);
    $[0] = checkOverflow;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isDisabledForChoice = t3;
  let t4;
  let t5;
  if ($[2] !== choices) {
    t5 = choices.some(_temp);
    $[2] = choices;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  t4 = t5;
  const isMediaInChoices = t4;
  let t6;
  if ($[4] !== choices || $[5] !== hideTooltip || $[6] !== isDisabledForChoice || $[7] !== isMediaInChoices || $[8] !== readOnly) {
    let t7;
    if ($[10] !== hideTooltip || $[11] !== isDisabledForChoice || $[12] !== isMediaInChoices || $[13] !== readOnly) {
      t7 = choice_1 => {
        const isDisabled = isDisabledForChoice(choice_1) || !!readOnly;
        const label = <div className={mergeTailwindClasses("flex w-full items-center gap-2", !readOnly && "cursor-pointer")}><p className="overflow-auto text-sm wrap-break-word">{choice_1.label}</p>{isMediaInChoices && <QuestionImage media={choice_1.media?.[0]} />}</div>;
        const renderedLabel = isDisabled && !hideTooltip ? <Tooltip content={t("survey.unavailableChoice")} placement="top" size="sm" trigger={label} /> : label;
        return {
          value: choice_1.id,
          label: renderedLabel,
          isDisabled,
          className: "w-full max-w-full px-0 [&>div]:flex-row [&>div]:w-full [&>div>span]:w-full"
        };
      };
      $[10] = hideTooltip;
      $[11] = isDisabledForChoice;
      $[12] = isMediaInChoices;
      $[13] = readOnly;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t6 = choices.filter(_temp2).map(t7);
    $[4] = choices;
    $[5] = hideTooltip;
    $[6] = isDisabledForChoice;
    $[7] = isMediaInChoices;
    $[8] = readOnly;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const items = t6;
  let t7;
  if ($[15] !== canSelectNoOption || $[16] !== onChange || $[17] !== value) {
    t7 = event => {
      const newValue = event.target.value;
      if (newValue === value && canSelectNoOption) {
        onChange(undefined);
        return;
      }
      onChange(newValue);
    };
    $[15] = canSelectNoOption;
    $[16] = onChange;
    $[17] = value;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleGroupChange = t7;
  let t8;
  if ($[19] !== handleGroupChange || $[20] !== items || $[21] !== value) {
    t8 = <div className="flex max-w-full flex-col gap-4"><RadioGroup label="" items={items} value={value} onChange={handleGroupChange} /></div>;
    $[19] = handleGroupChange;
    $[20] = items;
    $[21] = value;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
function _temp(t0) {
  const {
    media
  } = t0;
  return media && media.length > 0;
}
function _temp2(choice_0) {
  return choice_0.id !== undefined;
}